import $ from 'jquery';

function listenForFromChanges(formId) {
  var form = document.getElementById(formId);
  var inputs = form.querySelectorAll('input, select, textarea');

  inputs.forEach(function (input) {
    input.addEventListener('change', function (event) {
      console.log(event.target.name + ' changed to ' + event.target.value);
    });
  });
}


function handleAjaxFormSubmit() {
  const footerForm = document.querySelector('.footer form');
  const ajaxForms = document.querySelectorAll('.webform-submission-form');

  /* Handle the footer form submit */
  if (footerForm != null) {
    footerForm.addEventListener('submit', (e) => {
      e.preventDefault();
      var email = footerForm.querySelector('input[type="email"]').value;
      var htmlElement = document.documentElement;
      let langSlug = htmlElement.getAttribute('lang');
      if (langSlug == 'en') {
        langSlug = '';
      } else {
        langSlug = `/${langSlug}`;
      }
      window.location = `${langSlug}/join-our-community?email=${email}`;
    });
  }

  /* 
    If we land on the form page and we have a param in the url
    Prefill the form witht hat email value.
  */

  // Get the current URL
  const urlParams = new URLSearchParams(window.location.search);

  // Get the 'email' query parameter
  const email = urlParams.get('email');

  if (email != undefined && email.length) {
    var emailInput = document.querySelector('form input[type="email"]');
    //pre-populate the email input
    if (email) {
      emailInput.value = email;
    }
  }

  //Handle the contact form maipulation

  var jocForm = $('#webform-submission-join-the-movement-node-42-add-form');
 
  /* The inputs we will use to update the hidden fields */
  var jocFormFirstName = $('#edit-name-first');
  var jocFormLastName = $('#edit-name-last');
  var jocFormDOBMonth =  $('#edit-date-of-birth-items-0-month');
  var jocFormDOBDay = $('#edit-date-of-birth-items-0-day');
  var jocFormDOBYear = $('#edit-date-of-birth-items-0-year');
  var jocFormCountry =  $('#edit-country-country');

  /* The hidden inputs we will use to send data on submit */
  var jocFormHiddenFirstName = jocForm.find('input[name="firstname"]');
  var jocFromHiddenLastName = jocForm.find('input[name="lastname"]');
  var jocFormHiddenBirthDate = jocForm.find('input[name="birthdate"]');
  var jocFormHiddenMarket = jocForm.find('input[name="market"]');
  var jocFormHiddenLocationOfResidence = jocForm.find('input[name="locationofresidence"]');


  /*
  if (ajaxForms.length) {
    ajaxForms.forEach((el) => {
      el.addEventListener('submit', (e) => {
        e.preventDefault();

        
        // ** END -- Redirect the footer form with the email in URL

          const formData = new FormData(el);
          const actionUrl = el.getAttribute('action');

          fetch(actionUrl, {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then((response) => {
              console.log('Response:', response);
              console.log('Response code:', response.status);
              return response.text();  
            })
            .then((data) => {
              console.log('Success:', data);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
      });
    });
  }
  */
}
export default handleAjaxFormSubmit;
